import { SingleRadioItemModel } from '@ui-components';

export const gameVisibilityAll: string = 'true';
export const gameVisibilityPublicOnly: string = 'false';

export const availableGameVisibilityConst: SingleRadioItemModel<string>[] = [
  {
    name: 'Wszystkie',
    value: gameVisibilityAll,
    description: 'domyślne'
  },
  {
    name: 'Tylko publiczne',
    value: gameVisibilityPublicOnly
  }
];

export const gameVisibilityShortNameMap: Record<string, string> = {
  [gameVisibilityAll]: 'Wszystkie',
  [gameVisibilityPublicOnly]: 'Publiczne'
};
